import { sortBy } from 'lodash-es';
import { DateTime } from 'luxon';

import { RouteTemplateFormValues } from './types';

export function normalizeData(data: RouteTemplateFormValues) {
  const sortedMatchers = sortBy(data.trip_templates, (m) =>
    DateTime.fromISO(m.scheduled_pickup_time).toMillis()
  );

  const startTime = DateTime.fromISO(
    sortedMatchers[0].scheduled_pickup_time
  ).toFormat('HH:mm:ss');
  let endTime = DateTime.fromISO(
    sortedMatchers[sortedMatchers.length - 1].scheduled_pickup_time
  ).toFormat('HH:mm:ss');

  if (startTime === endTime) {
    endTime = DateTime.fromISO(sortedMatchers[0].scheduled_pickup_time)
      .plus({ hours: 1 })
      .toFormat('HH:mm:ss');
  }

  const rangeStart = data.range_start
    ? DateTime.fromISO(data.range_start).toISO()
    : undefined;
  const rangeEnd = data.range_end
    ? DateTime.fromISO(data.range_end).toISO()
    : undefined;

  return {
    ...data,
    sortedMatchers,
    startTime,
    endTime,
    rangeStart,
    rangeEnd,
  };
}
